const validScriptTypes: Array<string | null> = [
  "application/javascript",
  "text/javascript",
  "module",
  "",
  null,
];

const cleanCloneScript = (script: HTMLScriptElement) => {
  const newScript = document.createElement("script");
  newScript.innerHTML = script.innerHTML;
  if (script.hasAttributes()) {
    for (const attribute of script.attributes) {
      const { name, value } = attribute as Attr;
      newScript.setAttribute(name, value);
    }
  }
  return newScript;
};

const extractValidScripts = (htmlContainer: HTMLElement) => {
  const scripts = Array.from(htmlContainer.getElementsByTagName("script"));
  return Array.from(scripts).filter((script) =>
    validScriptTypes.includes(script.getAttribute("type")),
  );
};

const separateScriptTags = (htmlString = "") => {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = htmlString;

  const validScripts = extractValidScripts(wrapper);

  validScripts.forEach(
    (script) => script.parentNode && script.parentNode.removeChild(script),
  );

  const scripts = validScripts.map((script) => {
    script.parentNode?.removeChild(script);
    return cleanCloneScript(script);
  });

  return {
    scripts,
    htmlWithoutScripts: wrapper.innerHTML,
  };
};
export default separateScriptTags;
